import React from 'react';

export default function UTurnArrowIcon({ width = 24, height = 24, color = 'currentColor', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* U recostada hacia la izquierda */}
      <path d="M7 7h10a5 5 0 0 1 0 10H7" />
      <polyline points="7 2 2 7 7 12" />
    </svg>
  );
}
